import { useEffect, useState } from "react";
import { useForm } from "@mantine/form";
import {
  TextInput,
  Text,
  Paper,
  Group,
  Button,
  PasswordInput,
  Anchor,
  Stack,
  Container,
  Center,
  Loader,
  Divider,
} from "@mantine/core";
import { fetchInvite, userConfirmation } from "./authApi";
import { useStore } from "../store";
import { Link, useLocation } from "wouter";
import { socialLoginFactory } from "./socialLogin";
import { GoogleButton } from "../_Shared/GoogleButton";

export default function InvitationForm({ params, appName, hideGoogle, ...props }) {
  const [invitation, setInvitation] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  const form = useForm({
    initialValues: {
      password: "",
      emailAddress: "",
      terms: false,
      invitationToken: "",
    },
    validate: {
      emailAddress: (val) =>
        /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(val)
          ? null
          : "Invalid email",
      password: (val) =>
        val.length < 8 ? "Password must contain at least 8 characters" : null,
    },
  });

  const authToken = useStore((state) => state.authToken);
  const userLoggedIn = useStore((state) => state.userLoggedIn);
  // const setAuthToken = useStore((state) => state.setAuthToken);
  const [, setLocation] = useLocation();

  const socialLogin = socialLoginFactory((event) => {
    console.log("Social login callback invoked:", event.data);
    userLoggedIn(event.data);
  });

  useEffect(() => {
    if (authToken) {
      console.log("Auth token found, redirecting to home page");
      setLocation("/");
    }
  }, [authToken]);

  useEffect(() => {
    fetchInvite(params.token).then((data) => {
      form.setFieldValue("invitationToken", data.token);
      form.setFieldValue("emailAddress", data.emailAddress);
      setInvitation(data);
    });
  }, [params.token]);

  return (
    <Container size="xs" mt="xl">
      <Paper radius="md" p="xl" withBorder {...props}>
        {!invitation && (
          <Center>
            <Loader size="xl" mt="xl" />
          </Center>
        )}

        {invitation && (
          <Text my="md">
            You have been invited to join {invitation.inviterName}'s space on
            {appName}. Create an account now to accept it.
          </Text>
        )}

        {!hideGoogle && (
        <Group grow mb="md" mt="md">
          <GoogleButton
            onClick={() => socialLogin("Google", params.token)}
            radius="xl"
          >
            Google
          </GoogleButton>
        </Group>
        )}

        {!hideGoogle && (
        <Divider
          label="Or set a password to log in with email"
          labelPosition="center"
          my="lg"
        />
        )}

        <form
          onSubmit={form.onSubmit((values) => {
            setIsLoading(true);
            userConfirmation(values)
              .then((data) => {
                userLoggedIn(data);
                setIsLoading(false);
              })
              .catch((err) => {
                setIsLoading(false);
              });
          })}
        >
          <Stack>
            <TextInput
              label="Email"
              disabled
              value={form.values.emailAddress}
              radius="md"
            />

            <PasswordInput
              required
              label="Password"
              placeholder="Choose a new password"
              value={form.values.password}
              onChange={(event) =>
                form.setFieldValue("password", event.currentTarget.value)
              }
              error={form.errors.password}
              radius="md"
            />
          </Stack>

          <Group justify="space-between" mt="xl">
            <Anchor href="/auth/login" component={Link} c="dimmed" size="xs">
              Already have an account? Login!
            </Anchor>
            <Button
              loading={isLoading}
              disabled={!invitation}
              type="submit"
              radius="xl"
            >
              Accept invitation
            </Button>
          </Group>
        </form>
      </Paper>
    </Container>
  );
}
